module.exports = __webpack_public_path__ + "static/media/iconExport.4f7a2f4d.svg";